// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-wrapper[data-v-0420a306]{box-shadow:0 1px 3px transparent;display:block;left:0;position:sticky;right:0;top:0;transition:box-shadow .2s ease;z-index:11}.menu-wrapper.is-scrolling[data-v-0420a306]{box-shadow:0 -1px 10px 0 rgba(33,34,38,.31)}.menu-wrapper .text[data-v-0420a306]{color:#fff;font-size:.75rem;margin-bottom:0}@media screen and (min-width:768px){.menu-wrapper .text[data-v-0420a306]{font-size:1rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
